import _styled from "styled-components";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import { observer } from "mobx-react";
import { Fragment } from "react";
import isDefined from "../../Core/isDefined";
import parseCustomHtmlToReact from "../Custom/parseCustomHtmlToReact";
import { useViewState, withViewState } from "../Context";
import { useTheme } from "styled-components";
import { jsx as _jsx } from "react/jsx-runtime";
const DEFAULT_BRANDING = '<a target="_blank" href="http://terria.io"><img src="images/terria_logo.png" height="52" title="Version: {{ version }}" /></a>';
export default withViewState(observer(props => {
  var _props$viewState$terr, _props$version;
  // Set brandingHtmlElements to brandBarElements or default Terria branding as default
  let brandingHtmlElements = (_props$viewState$terr = props.viewState.terria.configParameters.brandBarElements) !== null && _props$viewState$terr !== void 0 ? _props$viewState$terr : [DEFAULT_BRANDING];
  if (props.viewState.useSmallScreenInterface) {
    var _ref;
    const brandBarSmallElements = props.viewState.terria.configParameters.brandBarSmallElements;
    const displayOne = props.viewState.terria.configParameters.displayOneBrand;

    // Use brandBarSmallElements if it exists
    if (brandBarSmallElements) brandingHtmlElements = brandBarSmallElements;
    // If no brandBarSmallElements, but displayOne parameter is selected
    // Try to find brand element based on displayOne index - OR find the first item that isn't an empty string (for backward compatability of old terriamap defaults)
    else if (isDefined(displayOne)) brandingHtmlElements = [(_ref = brandingHtmlElements[displayOne] || brandingHtmlElements.find(item => item.length > 0)) !== null && _ref !== void 0 ? _ref : DEFAULT_BRANDING];
  }
  const theme = useTheme();
  const viewState = useViewState();
  const logoHeight = viewState.useSmallScreenInterface ? theme.logoSmallHeight : theme.logoHeight;
  const version = (_props$version = props.version) !== null && _props$version !== void 0 ? _props$version : "Unknown";
  return /*#__PURE__*/_jsx(_StyledDiv, {
    $_css: logoHeight,
    $_css2: brandingHtmlElements.length > 0 ? "display: unset;" : "",
    children: brandingHtmlElements.map((element, idx) => /*#__PURE__*/_jsx(Fragment, {
      children: parseCustomHtmlToReact(element.replace(/\{\{\s*version\s*\}\}/g, version), {
        disableExternalLinkIcon: true
      })
    }, idx))
  });
}));
var _StyledDiv = _styled("div").withConfig({
  displayName: "Branding___StyledDiv",
  componentId: "sc-6c30oc-0"
})(["display:flex;justify-content:center;box-sizing:border-box;width:100%;min-height:", ";overflow:hidden;a{display:flex;-webkit-box-align:center;align-items:center;-webkit-box-pack:center;justify-content:center;}span{display:block;}img{max-height:100%;max-width:100%;}font-family:", ";padding:", " ", ";@media (max-width:", "px){height:", ";padding:", " ", ";a{", "}}"], p => p.$_css, p => p.theme.fontPop, p => p.theme.logoPaddingHorizontal, p => p.theme.logoPaddingVertical, p => p.theme.sm, p => p.theme.logoSmallHeight, p => p.theme.logoSmallPaddingHorizontal, p => p.theme.logoSmallPaddingVertical, p => p.$_css2);